import React from 'react';
import { Divider, Grid, Link, makeStyles, Typography } from '@material-ui/core';
import { HtmlText } from '../molcules/HtmlText';
import { DateTime } from 'luxon';
var useStyles = makeStyles(function (theme) { return ({
    section: {
        margin: theme.spacing(1),
    },
    infoSection: {
        padding: theme.spacing(1),
    },
}); });
export var Description = function (props) {
    var classes = useStyles();
    var validityRangeDescription = function () {
        return (React.createElement("span", null,
            props.validityStartDateTime
                ? DateTime.fromISO(props.validityStartDateTime).toFormat('yyyy年MM月dd日 HH:mm') + " \u304B\u3089"
                : '',
            props.validityStartDateTime ? React.createElement("br", null) : React.createElement(React.Fragment, null), DateTime.fromISO(props.validityEndDateTime).toFormat('yyyy年MM月dd日 HH:mm') + " \u307E\u3067"));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid, { container: true, direction: "row", justifyContent: "center", alignItems: "center" }, props.description ? (React.createElement(Grid, { item: true, xs: 12, className: classes.section },
            React.createElement(HtmlText, { text: props.description }))) : (React.createElement(React.Fragment, null))),
        React.createElement(Divider, null),
        React.createElement(Grid, { container: true, direction: "row", justifyContent: "center", alignItems: "center", className: classes.infoSection },
            props.displayValidityDate !== false && (React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                React.createElement(Typography, { variant: 'body2' }, "\u6709\u52B9\u671F\u9650"),
                React.createElement(Typography, { variant: 'body2' }, validityRangeDescription()))),
            props.information ? (React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                React.createElement(Typography, { variant: 'body2' }, "\u6CE8\u610F\u4E8B\u9805"),
                React.createElement(HtmlText, { text: props.information }))) : (React.createElement(React.Fragment, null)),
            React.createElement(Divider, { variant: 'middle' }),
            props.mapUrl ? (React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                React.createElement(Typography, { variant: 'body2' }, "\u5730\u56F3URL"),
                React.createElement(Link, { href: props.mapUrl, target: "_blank", rel: "noopener" }, "\u65B0\u3057\u3044\u30BF\u30D6\u3067\u958B\u304F"))) : (React.createElement(React.Fragment, null)),
            props.telNumber ? (React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                React.createElement(Typography, { variant: 'body2' }, "\u554F\u3044\u5408\u308F\u305B\u5148"),
                React.createElement(HtmlText, { text: props.telNumber }))) : (React.createElement(React.Fragment, null)))));
};
//# sourceMappingURL=Description.js.map